import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '@app/_services';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/_models';
import { environment } from '@environments/environment';
import { retry } from 'rxjs/operators';
import { SharedService } from './../_shared/shared.service';

@Injectable({
	providedIn: 'root'
})
export class RentalsUnitedService {

	ruAccounts: any[] =
		[
			{ name: "Production", value: "prod" },
			{ name: "Stage", value: "stage" },
			{ name: "Test", value: "test" },
			{ name: "Development", value: "dev" },
		]

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'rentals-united';

	// listBuildings(): Observable<ApiResponse> {
	// 	return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/buildings`);
	// }

	listBuildings(data: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/list-buildings`, data);
	}

	saveBuilding(building: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/buildings`, building);
	}


	// listProperties(ruAccount: any): Observable<ApiResponse> {
	// 	return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/properties/${ruAccount}`);
	// }

	listProperties(data: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/list-properties`, data);
	}

	saveProperty(property: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/properties`, property);
	}

	saveAllRuProperties(ruRequest: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/properties-save-all`, ruRequest);
	}

	pushAvailability(property: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/availabilities`, property);
	}

	listAvailability(post: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/availabilities/list`, post);
	}

	pushAllAvailability(post: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/availabilities/sync`, post);
	}

	pushPrices(post: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/prices`, post);
	}

	pushAllPrices(post: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/prices/sync`, post);
	}

	listPrices(post: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/prices/list`, post);
	}

	pushReservations(post: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/reservations`, post);
	}

	listReservations(post: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/reservations/list`, post);
	}

	syncAllReservations(post: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/reservations/sync`, post);
	}

	syncAllPropertiesStatus(): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/properties-status/sync-all`, {});
	}

	/**
	 * Hotel Room V2 — Quality Check
	 * POST /api/2.6/rentals-united/quality-check
	 * Compares WIKI (internal DB) vs live Rentals United availability and LOS pricing.
	 */
	qualityCheck(request: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/quality-check`, request);
	}
}
